var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5400",
    "data-name": "Group 5400",
    transform: "translate(0 0.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_364",
    "data-name": "Ellipse 364",
    transform: "translate(0 -0.237)",
    fill: "#fff",
    stroke: "#c3c3c3",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9064",
    "data-name": "Path 9064",
    d: "M10.7-8.306H-7.66q-4.319,0-5.168-2.622a13.564,13.564,0,0,1-.386-3.548,10.679,10.679,0,0,1,.463-3.471A3.193,3.193,0,0,1-11.285-19.8a8.338,8.338,0,0,1,3.7-.694H10.774q4.319,0,5.091,2.545a11.419,11.419,0,0,1,.463,3.548,11.984,11.984,0,0,1-.424,3.51A3.161,3.161,0,0,1,14.554-9,8.766,8.766,0,0,1,10.7-8.306Z",
    transform: "translate(42.955 59.081)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMinus);
export default __webpack_public_path__ + "static/media/btn_minus.37609c21.svg";
export { ForwardRef as ReactComponent };